import { useMutation } from '@tanstack/react-query';
import { signAgreement } from './api';

export const useSignAgreementMutation = () =>
  useMutation({ mutationFn: signAgreement });
